<template>
  <base-button class="btn-warning" text="所有者の方はこちら" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'UseAsOwnerButton',
  components: {
    BaseButton,
  },
}
</script>
